import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

type Props = {
  color?: string;
  size?: number;
};

const MapPinSvg: React.FC<Props> = ({color = '#07C1A0', size = 20}) => (
  <Svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <Path
      d='M12 22s7-6.148 7-12a7 7 0 1 0-14 0c0 5.852 7 12 7 12Z'
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
);

export default MapPinSvg;
